import css from 'styled-jsx/css';

export default css`
  amp-sidebar {
    width: 50vw;
    max-width: 375px;
    padding: 0.75rem;
    background-color: #fff;
    box-shadow: 2px 0px 6px #999;
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding: 0.5rem;
  }

  .AmpHeader__button {
    font-size: 1.5em;
    border: none;
    padding: 0;
    background-color: transparent;
    color: #000;
  }

  .AmpHeader__hamburger-close {
    font-size: 1.25em;
  }

  .AmpHeader__hamburger-open {
    grid-area: hamburger;
  }

  .AmpHeader__logo {
    grid-area: logo;
    margin: 0 auto;
    width: 140px;
  }

  .AmpHeader__logo--at {
    width: 216px;
  }

  .HamburgerNav nav {
    margin-bottom: 1rem;
    border-bottom: 1px solid #ddd;
    padding-bottom: 1rem;
  }

  .HamburgerNav ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .AmpHeader__xsite-link {
    font-family: sans-serif;
    font-size: 12px;
  }

  .AmpHeader__xsite-link :global(a) {
    margin-top: 0.25rem;
    display: block;
    width: 120px;
  }
`;
